import angular from 'angular';

function Filter() {
  return function(date) {
    if (angular.isNumber(date) || typeof date === 'string') {
      date = new Date(Number(date));
    }

    if (!date) return null;

    const offset = new Date().getTimezoneOffset();

    const time = date.getTime() + (offset * 60 * 1000);

    return new Date(time);
  };
}

Filter.$inject = [];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/localizeFilter.js